import { dynamicImport } from '@canvas/dynamic-import';
import type { ExternalMessageLoader } from '@canvas/intl';
import type { SupportedLocale } from '@canvas/intl-types';

import { combineExternalMessages } from './utils.ts';

export const smartCardMessagesMap: Record<SupportedLocale, ExternalMessageLoader[]> = {
  de: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/de'))],
  'en-GB': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/en_GB'))
  ],
  'en-US': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/en'))
  ],
  cs: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/cs'))],
  ko: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/ko'))],
  'pt-BR': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/pt_BR'))
  ],
  fr: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/fr'))],
  es: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/es'))],
  it: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/it'))],
  ja: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/ja'))],
  nl: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/nl'))],
  nb: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/nb'))],
  da: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/da'))],
  sv: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/sv'))],
  fi: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/fi'))],
  ru: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/ru'))],
  pl: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/pl'))],
  tr: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/tr'))],
  hu: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/hu'))],
  'zh-CN': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/zh'))
  ],
  'zh-TW': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/zh_TW'))
  ],
  // We prefer German translations for pseudo-locale as it is quite long and helps manually test
  'en-pseudo': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/de'))
  ],
  xx: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/de'))],
  en: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/en'))],
  'en-ZZ': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/en_ZZ'))
  ]
};

export const DatasourceMessagesMap: Record<SupportedLocale, ExternalMessageLoader[]> = {
  de: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/de'))
  ],
  'en-GB': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/en_GB'))
  ],
  'en-US': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/en'))
  ],
  cs: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/cs'))
  ],
  ko: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/ko'))
  ],
  'pt-BR': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/pt_BR'))
  ],
  fr: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/fr'))
  ],
  es: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/es'))
  ],
  it: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/it'))
  ],
  ja: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/ja'))
  ],
  nl: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/nl'))
  ],
  nb: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/nb'))
  ],
  da: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/da'))
  ],
  sv: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/sv'))
  ],
  fi: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/fi'))
  ],
  ru: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/ru'))
  ],
  pl: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/pl'))
  ],
  tr: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/tr'))
  ],
  hu: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/hu'))
  ],
  'zh-CN': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/zh'))
  ],
  'zh-TW': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/zh_TW'))
  ],
  // We prefer German translations for pseudo-locale as it is quite long and helps manually test
  'en-pseudo': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/de'))
  ],
  xx: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/de'))
  ],
  en: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/en'))
  ],
  'en-ZZ': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/en_ZZ'))
  ]
};

export const EmojiMessagesMap: Record<SupportedLocale, ExternalMessageLoader[]> = {
  de: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/de'))],
  'en-GB': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/en_GB'))],
  'en-US': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/en'))],
  cs: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/cs'))],
  ko: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/ko'))],
  'pt-BR': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/pt_BR'))],
  fr: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/fr'))],
  es: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/es'))],
  it: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/it'))],
  ja: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/ja'))],
  nl: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/nl'))],
  nb: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/nb'))],
  da: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/da'))],
  sv: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/sv'))],
  fi: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/fi'))],
  ru: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/ru'))],
  pl: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/pl'))],
  tr: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/tr'))],
  hu: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/hu'))],
  'zh-CN': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/zh'))],
  'zh-TW': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/zh_TW'))],
  // We prefer German translations for pseudo-locale as it is quite long and helps manually test
  'en-pseudo': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/de'))],
  xx: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/de'))],
  en: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/en'))],
  'en-ZZ': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/en_ZZ'))]
};

export const ReactionsMessagesMap: Record<SupportedLocale, ExternalMessageLoader[]> =
  combineExternalMessages(EmojiMessagesMap, {
    de: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/de'))],
    'en-GB': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/en_GB'))
    ],
    'en-US': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/en'))
    ],
    cs: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/cs'))],
    ko: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/ko'))],
    'pt-BR': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/pt_BR'))
    ],
    fr: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/fr'))],
    es: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/es'))],
    it: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/it'))],
    ja: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/ja'))],
    nl: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/nl'))],
    nb: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/nb'))],
    da: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/da'))],
    sv: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/sv'))],
    fi: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/fi'))],
    ru: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/ru'))],
    pl: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/pl'))],
    tr: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/tr'))],
    hu: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/hu'))],
    'zh-CN': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/zh'))
    ],
    'zh-TW': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/zh_TW'))
    ],
    // We prefer German translations for pseudo-locale as it is quite long and helps manually test
    'en-pseudo': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/de'))
    ],
    xx: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/de'))],
    en: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/en'))],
    'en-ZZ': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/en_ZZ'))
    ]
  });

export const ConversationAssistantMessagesMap: Record<
  SupportedLocale,
  ExternalMessageLoader[]
> = {
  de: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/de')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/de')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/de')
      )
  ],
  'en-GB': [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/en_GB')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/en_GB')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/en_GB')
      )
  ],
  'en-US': [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/en')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/en')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/en')
      )
  ],
  cs: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/cs')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/cs')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/cs')
      )
  ],
  ko: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/ko')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/ko')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/ko')
      )
  ],
  'pt-BR': [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/pt_BR')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/pt_BR')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/pt_BR')
      )
  ],
  fr: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/fr')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/fr')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/fr')
      )
  ],
  es: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/es')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/es')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/es')
      )
  ],
  it: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/it')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/it')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/it')
      )
  ],
  ja: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/ja')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/ja')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/ja')
      )
  ],
  nl: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/nl')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/nl')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/nl')
      )
  ],
  nb: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/nb')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/nb')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/nb')
      )
  ],
  da: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/da')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/da')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/da')
      )
  ],
  sv: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/sv')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/sv')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/sv')
      )
  ],
  fi: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/fi')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/fi')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/fi')
      )
  ],
  ru: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/ru')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/ru')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/ru')
      )
  ],
  pl: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/pl')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/pl')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/pl')
      )
  ],
  tr: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/tr')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/tr')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/tr')
      )
  ],
  hu: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/hu')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/hu')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/hu')
      )
  ],
  'zh-CN': [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/zh')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/zh')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/zh')
      )
  ],
  'zh-TW': [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/zh_TW')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/zh_TW')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/zh_TW')
      )
  ],
  'en-pseudo': [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/de')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/de')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/de')
      )
  ],
  xx: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/de')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/de')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/de')
      )
  ],
  en: [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/en')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/en')
      ),
    () =>
      dynamicImport(
        () => import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/en')
      )
  ],
  'en-ZZ': [
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-blank-object-experience/i18n/en_ZZ')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-ai-mate-conversation-assistant-chat-prompt-input/i18n/en_ZZ')
      ),
    () =>
      dynamicImport(
        () =>
          import('@atlassian/afm-i18n-platform-insights-ai-platform-ai-audio/i18n/en_ZZ')
      )
  ]
};
